module.exports = __webpack_public_path__ + "images/services/kiln.6c1d65d72873b01d740a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/services/kiln.png
// module id = q6tB
// module chunks = 2